<template>
  <v-row class="mx-0 text-center text--secondary d-flex justify-center align-center align-content-center placeholder">
    <v-col cols="12">
      <span class="d-block">{{ title }}</span>
    </v-col>
    <v-col
      v-if="buttonTitle"
      cols="12"
    >
      <v-btn
        outlined
        small
        color="primary"
        @click="$emit('click')"
      >
        {{ buttonTitle }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts">

import Vue from 'vue';

export default Vue.extend({
  name: 'GuestListPlaceholder',
  props: {
    title: { type: String, required: false, default: '' },
    buttonTitle: { type: String, required: false, default: null },
  },
  data() {
    return { };
  },
});

</script>

<style scoped>

  .placeholder {
    height: 70vh;
  }

</style>
